import { useState, useEffect } from 'react';

/**
 * @param value 需要防抖的值（如输入框的文本）
 * @param delay 延迟时间（毫秒），默认 500ms
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // 设置定时器
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // 每次 value 变化时，清除上一次的定时器（这是防抖的核心）
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}